import React, { createContext, useContext } from 'react';
import { 
  navigationStyles,
  headerStyles,
  cardStyles,
  projectInfoStyles,
  layoutStyles,
  buttonStyles,
  formStyles,
  tableStyles
} from '../styles/components';

const StyleContext = createContext();

export const useStyles = () => {
  const context = useContext(StyleContext);
  if (!context) {
    throw new Error('useStyles must be used within a StyleProvider');
  }
  return context;
};

export const StyleProvider = ({ children }) => {
  const styles = {
    navigation: navigationStyles,
    header: headerStyles,
    card: cardStyles,
    projectInfo: projectInfoStyles,
    layout: layoutStyles,
    button: buttonStyles,
    form: formStyles,
    table: tableStyles,
  };

  return (
    <StyleContext.Provider value={styles}>
      {children}
    </StyleContext.Provider>
  );
};
